<div class="dialogHeader" [ngClass]="data?.titleClass">
  <h2 mat-dialog-title >{{ data.title }}</h2>
</div>
<div mat-dialog-content>
  <p class="confirm-text" [innerHtml]="data?.message"></p>
</div>
<div class="dialogContentContainer">
  <div mat-dialog-actions align="end">
    @if (!data?.hideCancel) {
      <button
        mat-button
        mat-dialog-close
        (click)="cancel()"
        class="dialog-cancel-button"
        >
        Cancel
      </button>
    }
    <button
      mat-button
      mat-raised-button
      cdkFocusInitial
      (click)="confirm()"
      color="accent"
      class="dialog-confirm-button"
      [ngClass]="data?.buttonClass"
      >
      {{ data.buttonText }}
    </button>
  </div>
</div>
